// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kvY8","title":"styles_title__v29pf"};